export default __webpack_public_path__ + "static/object-tile-smaller-do-33d2386d61454b8738fdde4da374923a.png";